import { KioskAccessList as List } from "./list";

export const KioskAccess = { List };
